import type { AccessibleFolderMeta } from '@affine/core/modules/organize';

const isPrivateSystemFolder = (folder: AccessibleFolderMeta): boolean =>
  folder.systemKind === 'private_root' || folder.systemKind === 'private_mail';

export function isDocInsidePrivateSystemFolder(
  docId: string,
  folders: AccessibleFolderMeta[]
): boolean {
  const foldersById = new Map(folders.map(folder => [folder.id, folder]));
  const directFolder =
    folders.find(folder => folder.docIds.includes(docId)) ?? null;

  let folder: AccessibleFolderMeta | null = directFolder;
  const visited = new Set<string>();

  while (folder) {
    if (visited.has(folder.id)) return false;
    visited.add(folder.id);
    if (isPrivateSystemFolder(folder)) return true;
    folder = folder.parentId
      ? (foldersById.get(folder.parentId) ?? null)
      : null;
  }

  return false;
}
